import {IModalService, IModalInstanceService} from "angular-ui-bootstrap";
import {IPromise, IScope} from "angular";

// interface ControllerScope extends IScope {
//     // watchTheVideo: () => void;
// }

export class TradingLevelWarningDialog {

    public static id = "tradingLevelWarningDialog";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(): IPromise<any> {
        const instance = this.$uibModal.open({
                                                 templateUrl: "app/portfolio/templates/ticket/services/trading-level-warning/TradingLevelWarningDialog.html",
                                                 backdrop: "static",
                                                 /** @ngInject */
                                                 controller: (
                                                     // $scope: ControllerScope,
                                                     $uibModalInstance: IModalInstanceService) => {
                                                 }
                                             });

        return instance.result;
    }
}
